/* src/app/invoice/pages/sage-export-build/sage-export-build.component.scss */
.faultList {
  max-height: 40vh;
  overflow-y: auto;
}
.excludedList {
  max-height: 40vh;
  overflow-y: auto;
}
.excludedList a {
  text-decoration: underline;
}
/*# sourceMappingURL=sage-export-build.component.css.map */
